import React from 'react';
import {post} from '../utils/request';
import { Toast } from 'antd-mobile';
import api from './api';

import './index.less';

class GradeDescription extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
        detail: {}, //详情
    }
  }
  componentDidMount(){
    var obj = '',obj1 = '',ops={};
    if(window.location.hash.indexOf('?') > -1 ){
        obj = window.location.hash.split('?')[1];
        obj1 = obj.split('&');
        for(var i=0;i<obj1.length;i++){
            ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        }
        if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
            Toast.fail('请先登录APP',999);
            return;
        }
        
        this.setState({
            urlOps: ops
        },()=>{
            if(ops.app_stoken && ops.app_stoken != 'null'){
                this.selectBdDictionary();
            }
        });
    }

  }

  selectBdDictionary= () => {
    const {urlOps} = this.state;

    post({ 
        url:api.selectBdDictionary + '?app_stoken=' + urlOps.app_stoken,
        preventXXSKey: 'description',
        data: {
            dictionaryCode: 'PARTY_DESCRIPTION',
        } }).then((res) => {
            if(res.result === 'success'){
                this.setState({
                    detail: res.data,
                });
            }else{
                Toast.info(res.msg,1);
            }

        },(res)=>{
            Toast.info(res.msg,1);
        });
}

  render() {
    const {
        detail,
    } = this.state;
    return (
        <div className="page_type_h5">
            <div className='wang-editor-normal'>
                <div id="GradeDescription" dangerouslySetInnerHTML={{ __html: detail.description }} />
            </div> 
        </div>
    );
  }
}

export default GradeDescription;



// WEBPACK FOOTER //
// ./src/gradeDescription/index.js